var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.headerIsShow)?_c('div',{staticClass:"clearfix",attrs:{"id":"header"}},[_c('div',{staticClass:"tohomepage",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("../../assets/img/back.png")}})]),_vm._v(" "),_c('span',{staticClass:"examplename"},[_vm._v(_vm._s(_vm.examplename))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2dc3164","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobleHeader/index.vue
// module id = null
// module chunks = 